import base from "./base";

const notificationAPI = dispatch => {
    return {
      async getMessages(data) {
        const response = await base.privateApi(dispatch, {
          path: `/notification/list`,
          method: 'post',
          data
        });
        return response;
      },
      async getUnreadNo() {
        const response = await base.privateApi(dispatch, {
          path: `/notification/unreadNo`,
          method: 'get'
        });
        return response;
      },
      async readMessages(data) {
        const response = await base.privateApi(dispatch, {
          path: `/notification/read`,
          method: 'post',
          data
        });
        return response;
      }
    };
  };
  
  export default notificationAPI;